import { useAutoneTranslation } from '@autone/translations';
import {
  createColumnLoadingGuards,
  DataTableCellContent,
  DataTableCellPerc,
  DataTableCellTitle,
  type DataTableLoadingObject,
} from '@autone/ui';
import { type ColumnHelper } from '@tanstack/react-table';

import { type APP_NAME } from '../../../../consts';

const COLUMN_ID = 'perc_locations_assorted' as const;

export type PercLocationsAssortedColumnId = typeof COLUMN_ID;

interface PercLocationsAssortedFields {
  assorted_locations_pct: number;
}

const { columnCellGuard, accessorFnGuard } =
  createColumnLoadingGuards<PercLocationsAssortedFields>();

export const createPercLocationsAssortedColumn = <
  T extends PercLocationsAssortedFields | DataTableLoadingObject,
>(
  columnHelper: ColumnHelper<T>,
) =>
  columnHelper.accessor(
    accessorFnGuard((row) => row.assorted_locations_pct),
    {
      id: COLUMN_ID,
      size: 150,
      header: function StoresAssortedHeader() {
        const { t } = useAutoneTranslation<typeof APP_NAME>();
        return (
          <DataTableCellContent align={'right'}>
            <DataTableCellTitle className="uppercase font-medium">
              {t('table-columns.perc-locations-assorted')}
            </DataTableCellTitle>
          </DataTableCellContent>
        );
      },
      cell: (ctx) =>
        columnCellGuard({
          ctx,
          renderCell: function StoresAssortedCell({ getValue }) {
            return (
              <DataTableCellContent align={'right'}>
                <DataTableCellTitle>
                  <DataTableCellPerc value={getValue()} />
                </DataTableCellTitle>
              </DataTableCellContent>
            );
          },
        }),
    },
  );
